// This pack is to support the froala on the old version of sidebar
// If you're writing anything for a new view, please use application.js instead

import 'froala-editor.js';
import '../src/styles/vendors/froala';
